module.exports = __webpack_public_path__ + "static/media/warning-flag.3a8e24cc.svg";